import "./App.css";
import Navbar from "./components/layout/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "./components/layout/Footer";
import "bootstrap-icons/font/bootstrap-icons.css";
import AboutMission from "./components/sections/about/AboutMission";
import ServicesPage from "./pages/ServicesPage";
import RequestPage from "./pages/RequestPage";
import PackagesPage from "./pages/PackagesPage";
import ContactPage from "./pages/ContactPage";
import { LanguageProvider } from "./i18n/LanguageContext";



function App() {
  // Initialize AOS when the app mounts
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration (1 second)
      once: true,     // animation runs only once when element enters viewport
    });

    // Refresh ensures AOS detects all elements correctly
    AOS.refresh();
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutMission />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/packages" element={<PackagesPage />} />
            <Route path="/request" element={<RequestPage />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
